import { StyledModal } from '@app/components/modal/Modal';
import type { Location } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { LocationForm, type LocationFormValues } from './LocationForm';
import useLocationActions from '@app/hooks/locations/useLocationActions';

export type LocationEditModalProps = ModalProps & {
    title?: string;
    data?: Location;
};

export const LocationEditModal = ({
    title = 'Edit Admin Location',
    data,
    onOk,
    ...props
}: LocationEditModalProps) => {
    const { editLocation } = useLocationActions();
    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    const handleSubmit = (values: LocationFormValues & { channel_id: string }) => {
        if (data) {
            const formData = { ...values, id: data.id };
            editLocation.mutate(formData, {
                onSuccess: () => {
                    if (onOk) {
                        onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                    }
                },
            });
        }
    };

    return (
        <StyledModal
            title={title}
            maskClosable={false}
            width={680}
            footer={null}
            className="modal-body-scroll"
            {...props}>
            <LocationForm
                id="admin-location-edit"
                data={data}
                isEdit={true}
                onCancel={props.onCancel}
                loading={editLocation.isPending}
                onSubmit={handleSubmit}
            />
        </StyledModal>
    );
};
